<template>
     <modal
        name="rules-modal-step5"
        :click-to-close="true"
        height="auto"
        :scrollable="true"
        :width="340"
    >
        <div class="rules-modal">
            <div class="rules-modal__close">
                <img @click="closeRulesModal()" src="/images/icons/step-5-icons/close-rules-modal.svg" alt="Close rules modal">
            </div>
            <div class="rules-modal__content">
                <div class="rules-modal__icon">
                    <img src="/images/icons/step-5-icons/rules-modal-warning.svg" alt="Warning icon">
                </div>
                <div class="rules-modal__text">
                    <h3 class="rules-modal__text__heading">
                        Note
                    </h3>
                    <p class="rules-modal__text__body">
                        The selected motherboard will not support the USB-C port that’s included with the selected case.
                    </p>
                </div>
                <button @click="closeRulesModal()" class="rules-modal__button">
                    OKAY
                </button>
            </div>
        </div>
     </modal>
</template>

<script>
export default {
    name: "RulesModalStep5",
    methods: {
        closeRulesModal() {
            this.$modal.hide("rules-modal-step5");
        },
    }
}
</script>

<style lang="scss">
.v--modal-overlay[data-modal="rules-modal-step5"] {
    background-color: rgba(0, 0, 0, 0.88) !important;

    .v--modal-box {
        background-color: transparent;
        max-width: 100%;
    }

    .v--modal {
        border-radius: 2px;
        box-shadow: none;
    }
}
</style>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.rules-modal {
    background-color: #252525;
    padding: 15px;

    &__close {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 55px;
        cursor: pointer;
    }

    &__content {
        padding: 0 15px 80px;
        color: $white;
    }

    &__icon {
        display: flex;
        justify-content: center;
    }

    &__text {
        text-align: center;

        &__heading {
            font-family: "Akkurat-Light";
            margin: 10px 0 5px;
        }

        &__body {
            opacity: .7;
            opacity: 0.7;
            font-size: 16px;
            line-height: 21px;
            margin-bottom: 30px;
        }
    }

    &__button {
        background: #72178F;
        font-size: 14px;
        width: 100%;
        border-radius: 2px;
        height: 50px;
        border: none;
        transition: all .2s;

        &:hover {
            background: $white;
            color: #72178F;
        }
    }
}
</style>